import { render, staticRenderFns } from "./busca.vue?vue&type=template&id=2d93186b"
import script from "./busca.vue?vue&type=script&lang=js"
export * from "./busca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports